export const EXPIRES_IN: number = 3600;

export const BASE_URL: string = 'https://symble-api.onrender.com/api/';
